// Mobile-only alias of /log-in, intentionally excluded from app Universal/App Link rules
// so the OS opens it in the browser. Server-rewritten to /log-in (see next.config.mjs).
const NO_APP_LOG_IN_PATH = '/no-app/log-in'
const DEFAULT_LOG_IN_PATH = '/log-in'

export function getLoginCallbackPath(): string {
  if (typeof window === 'undefined') {
    return DEFAULT_LOG_IN_PATH
  }

  const pathname = window.location.pathname

  return pathname === NO_APP_LOG_IN_PATH ? NO_APP_LOG_IN_PATH : DEFAULT_LOG_IN_PATH
}

/** Convenience: full origin-qualified URL for `redirectSignIn`. */
export function getLoginCallbackUrl(origin: string): string {
  return `${origin}${getLoginCallbackPath()}`
}
